export default {
  props:['map','value'],
  data(){
    return {
      trafficActive:false,
    }
  },
  created(){
    this.$watch('value' , function(nv){
      this.trafficActive = !!nv
      this.toggleTraffic()
    },{immediate:true})
  },
  methods:{
    toggleTraffic(visible){
      if( !this.map ) return
      if (!this.trafficLayer) {
        this.trafficLayer = new AMap.TileLayer.Traffic();
      }
      if( visible !== undefined ){
        this.trafficActive = visible
      }else{
        this.trafficActive = !this.trafficActive
      }
      if (this.trafficActive) {
        this.map.add(this.trafficLayer)
      } else {
        this.map.remove(this.trafficLayer)
      }
    }
  },
  render(){
    let styles = {color:'#5f6477'}
    if( this.trafficActive ) styles.color = '#4285F4'
    return <a style={styles} on-click={() => this.toggleTraffic()}>
      <Icon custom="i-icon icon-traffic" />
      <span>路况</span>
    </a>
  }
}